function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 74,
  height: 74,
  fill: "#D9D9D9"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_4185_3150)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M49.1553 52.4645L52.049 49.5707C52.3177 49.3056 52.4521 48.996 52.4521 48.6419C52.4521 48.2883 52.3177 47.9772 52.049 47.7084L40.3208 35.9625C40.6445 35.3576 40.8876 34.7034 41.05 33.9999C41.2118 33.2959 41.2928 32.5251 41.2928 31.6874C41.2928 28.9705 40.3218 26.6467 38.3798 24.716C36.4378 22.7858 34.1001 21.8208 31.3668 21.8208C30.6118 21.8208 29.8983 21.905 29.2261 22.0736C28.5545 22.2416 27.9024 22.4754 27.2698 22.775L33.6854 29.25L28.8947 34.0415L22.3603 27.5665C22.0674 28.1909 21.8351 28.851 21.6635 29.5468C21.4913 30.2426 21.4053 30.968 21.4053 31.7229C21.4053 34.4562 22.3763 36.7939 24.3183 38.7359C26.2602 40.6779 28.5979 41.6489 31.3313 41.6489C32.1134 41.6489 32.8506 41.5579 33.5428 41.376C34.235 41.1941 34.9229 40.9608 35.6063 40.6761L47.3531 52.4051C47.6218 52.6739 47.9222 52.818 48.2542 52.8375C48.5861 52.8576 48.8865 52.7332 49.1553 52.4645ZM37.01 64.75C33.1728 64.75 29.5651 64.0218 26.1868 62.5655C22.809 61.1091 19.8705 59.1327 17.3715 56.6362C14.8725 54.1397 12.8942 51.2039 11.4369 47.8287C9.97895 44.454 9.25 40.8477 9.25 37.01C9.25 33.1728 9.97818 29.5651 11.4345 26.1867C12.8909 22.809 14.8673 19.8705 17.3638 17.3715C19.8603 14.8725 22.7961 12.8942 26.1713 11.4369C29.546 9.97895 33.1523 9.25 36.99 9.25C40.8272 9.25 44.4349 9.97818 47.8133 11.4345C51.191 12.8909 54.1295 14.8673 56.6285 17.3638C59.1275 19.8603 61.1058 22.7961 62.5631 26.1713C64.021 29.546 64.75 33.1523 64.75 36.99C64.75 40.8272 64.0218 44.4349 62.5655 47.8132C61.1091 51.191 59.1327 54.1295 56.6362 56.6285C54.1397 59.1275 51.2039 61.1058 47.8287 62.5631C44.454 64.021 40.8477 64.75 37.01 64.75ZM37 61.6667C43.8861 61.6667 49.7188 59.2771 54.4979 54.4979C59.2771 49.7188 61.6667 43.8861 61.6667 37C61.6667 30.1139 59.2771 24.2812 54.4979 19.5021C49.7188 14.7229 43.8861 12.3333 37 12.3333C30.1139 12.3333 24.2812 14.7229 19.5021 19.5021C14.7229 24.2812 12.3333 30.1139 12.3333 37C12.3333 43.8861 14.7229 49.7188 19.5021 54.4979C24.2812 59.2771 30.1139 61.6667 37 61.6667Z",
  fill: "white"
}));

function SvgBuildCircle(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4185_3150",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 74,
    height: 74
  }, _ref2), _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildCircle);
export default __webpack_public_path__ + "static/media/buildCircle.eb29856fe40d62f7ebbb974712033f14.svg";
export { ForwardRef as ReactComponent };